import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SessionService} from 'src/app/services/session.service';
import {DialogService} from '../../../../services/dialog.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Router} from '@angular/router';

@Component({
    selector: 'app-create-account',
    templateUrl: './create-account.component.html',
    styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {
    @Input() active: boolean;
    form: FormGroup;
    accountCreated: boolean;
    userData: any;
    isBusiness = false;
    public hide = true;
    countries: any;
    productsList: any;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private fb: FormBuilder,
        private dialogService: DialogService,
        private sessionService: SessionService,
        private deviceService: DeviceDetectorService,
        private router: Router
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.userData = this.sessionService.getPaymentAccount();
        if (this.userData && this.userData.user !== '' && this.userData.user !== null) {
            this.addDataLayer();
            this.refreshSteps();
        }
    }

    ngOnInit(): void {
    }

    createAccount(): void {
        this.sessionService.setInitText(true);
        setTimeout(() => {
            if (this.router.url === '/firma-digital-gratis') {
                this.sessionService.emitNewSessionText(true);
            } else {
                this.router.navigate(['/firma-digital-gratis']);
            }
        }, 200);
    }

    refreshSteps(): void {
        const steps = this.sessionService.getPaymentSteps();
        this.accountCreated = steps.accountStep.completed;
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {step: 1, option: 'Sesion iniciada'},
                }
            }
        });
    }

}
